import { createClient } from '@supabase/supabase-js';
import { Capacitor } from '@capacitor/core';
import { createSupabaseAuthStorage, usesIosAuthStorage } from './utils/supabaseAuthStorage';
import { setNetworkRetryNotifier, timedFetch } from './shared/timedFetch';
import { showToast } from './components/Toast';
import { RETRYING_MESSAGE } from './shared/connectionCopy';

setNetworkRetryNotifier(() => {
  showToast(RETRYING_MESSAGE, 'info', 4000);
});

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

function nativeAuthLock(_name, _acquireTimeout, fn) {
  return fn();
}

function authConfig() {
  const auth = {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  };
  if (usesIosAuthStorage(Capacitor)) {
    auth.storage = createSupabaseAuthStorage();
  }
  if (Capacitor && typeof Capacitor.isNativePlatform === 'function' && Capacitor.isNativePlatform()) {
    auth.lock = nativeAuthLock;
  }
  return auth;
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: authConfig(),
  global: {
    fetch: timedFetch,
  },
  db: {
    schema: 'public'
  }
});
